import React, { forwardRef } from 'react';

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt: string;
  src: string;
}

const EDImage = forwardRef<HTMLImageElement, IProps>((props, ref) => {
  const { src, alt, ...rest } = props;

  return <img src={src} alt={alt} ref={ref} {...rest} />;
});

export default EDImage;
